import angular from 'angular';
import geolocation from 'angularjs-geolocation';

// Libraries

// Translations
import translation from '../../../../../lib/translation';

// Load all services
import serviceModuleName from '../../../../../lib/service';

// Load filters
import filters from '../../../../../lib/filters';

// Task queue
import taskQueueServiceModule from '../../../../../lib/service/TaskQueueService';

// Component
import component from './claimDisplayBox.component';

// Dependencies
import claimsModal from '../claimsModal';
import constants from '../../../../../lib/constants';
import confirmModal from '../../../../../lib/components/modals/confirmModal';

const moduleName = 'staff.dashboardScreen.claimDisplayBox';
let module = angular.module(moduleName, [
  translation,
  'angularMoment',
  serviceModuleName,
  filters.name,
  claimsModal.name,
  constants,
  confirmModal.name,
  taskQueueServiceModule.name,
]);

module.component('claimDisplayBox', component);

export default module;
